import api from "./api";

const salaryMasterService = {
  // All employees with their latest salary structure
  getAll: (params) => api.get("/salary-master", { params }),

  // Revision history for one employee
  getEmployeeHistory: (employeeId) =>
    api.get(`/salary-master/employee/${employeeId}`),

  // Single record
  getById: (id) => api.get(`/salary-master/${id}`),

  // Create (new structure or revision)
  create: (data) => api.post("/salary-master", data),

  // Update existing
  update: (id, data) =>
    api.put(`/salary-master/${id}`, data),

  // Delete
  remove: (id) => api.delete(`/salary-master/${id}`),
};

export default salaryMasterService;
